import type { Web3TxMultiCalcSWR } from "@/hooks/tx-flow/useDepositCalculate";
import type { ResponseDepositStart } from "@/hooks/tx-flow/useDepositStart";
import { type Dispatch, type SetStateAction, useEffect } from "react";

import { FixedNumber } from "@ethersproject/bignumber";
import useEstimateTx from "@/hooks/viem/useViemEstimateTx";
import { parseUnits, formatUnits } from "viem";

interface useGetTotalTransactionFeeProps {
  depositStartData: ResponseDepositStart | undefined;
  setTotalGasCost: Dispatch<SetStateAction<number | undefined>>;
  calculatedRoutes: Web3TxMultiCalcSWR;
}

/**
 * Hook that helps to calculate the total fess: paymaster fee, tx gas fee and edge-case native token difference
 * Used for both deposit and withdraw
 */
export default function useGetTotalTransactionFee({ depositStartData, setTotalGasCost, calculatedRoutes }: useGetTotalTransactionFeeProps) {
  const gasPriceUsd = calculatedRoutes.data ? calculatedRoutes.data[0].in.gas_estimate?.gas_price_usd ?? "0" : "0";
  const amountOfGas = useEstimateTx(depositStartData?.data, depositStartData?.to, depositStartData?.value);
  const gasPrice = parseUnits(gasPriceUsd, 18);

  useEffect(() => {
    if (!amountOfGas || gasPrice === 0n) {
      return setTotalGasCost(undefined);
    }
    setTotalGasCost(FixedNumber.from(formatUnits(amountOfGas * gasPrice, 18)).toUnsafeFloat());
  }, [amountOfGas, gasPrice, setTotalGasCost]);
}
